import { FaChartBar, FaTimes } from "react-icons/fa"
import SearchIcon from "@mui/icons-material/Search"
import { Button } from "@mui/material"
import { toast } from "react-toastify"
import { useEffect, useState } from "react"
import { BACKEND } from "../config/configEnvs"
import axios from "axios"
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen"
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen"
import { getToday } from "../utils/GetDates"
import React from "react"
import { GetDynamicColor, GetStatusColor } from "../utils/GetTextColor"
import { useSelector } from "react-redux"
import DetailsButton from "../components/ui/components/DetailsButton"

const DashboardActividadesComercial = () => {

  const user = useSelector((state) => state.auth.user)
  const isAdmin = user.area.toUpperCase() === "ADMINISTRACION"
  const selectedUserForAdmin = !isAdmin ? user.id : ""

  const [loadingStatus, setLoadingStatus] = useState(false);

  const [events, setEvents] = useState([]);
  const [sellers, setSellers] = useState([]);
  const [valoresKPIs, setValoresKPIs] = useState([]);
  const [workerKPIs, setWorkerKPIs] = useState({});

  const eventosLlamadas = events.filter(event => event.eventType === "Llamada")
  const eventosMeets = events.filter(event => event.eventType === "Google Meet")
  const eventosEntradas = events.filter(event => event.eventType === "Entrada al sistema")
  const eventosCotizaciones = events.filter(event => event.eventType === "Cambio estado cotización")

  const [totalPages, setTotalPages] = useState(0);
  const [totalDocs, setTotalDocs] = useState(0);
  // const [page, setPage] = useState(1);
  // const [limit, setLimit] = useState(25);

  const [searchCriteria, setSearchCriteria] = useState("leadName");
  const [leadName, setLeadName] = useState("");

  const [eventType, setEventType] = useState("");
  const [eventSubType, setEventSubType] = useState("");

  const [leadStatus, setLeadStatus] = useState("");
  const [selectedSeller, setSelectedSeller] = useState(selectedUserForAdmin);

  const { start, end } = getToday()
  
  // Ajustar las fechas para que incluyan todo el día
  const [startDate, setStartDate] = useState(() => {
    const date = new Date(start);
    date.setUTCHours(0, 0, 0, 0);
    return date.toISOString();
  });
  
  const [endDate, setEndDate] = useState(() => {
    const date = new Date(end);
    date.setUTCHours(23, 59, 59, 999);
    return date.toISOString();
  });

  const ColorMapKPIs = [
    { min: 0, max: 25, color: "text-red-500" },
    { min: 25, max: 50, color: "text-yellow-400" },
    { min: 50, max: 75, color: "text-green-500" },
    { min: 75, max: 1000, color: "text-blue-500" }
  ];

  const getEvents = async () => {
    try {
      setLoadingStatus(true)

      let url = `${BACKEND}/api/eventosLeads?limit=0`

      let andFilters = [];

      if (eventType) {
        url += `&where[eventType][equals]=${eventType}`
      }

      if (eventSubType) {
        url += `&where[eventSubType][equals]=${eventSubType}`
      }

      if (startDate) {
        const adjustedStartDate = new Date(startDate);
        adjustedStartDate.setHours(adjustedStartDate.getHours() + 5);
        andFilters.push({
          createdAt: {
            greater_than_equal: adjustedStartDate?.toISOString(),
          }
        })
      }
    
      if (endDate) {
        const adjustedEndDate = new Date(endDate);
        adjustedEndDate.setHours(adjustedEndDate.getHours() + 29);
        andFilters.push({
          createdAt: {
            less_than_equal: adjustedEndDate?.toISOString(),
          }
        })
      }

      if (leadName) {
        console.log(leadName)
        if (searchCriteria === "leadName") {
          url += `&where[lead.leadName][like]=${leadName}`
        } else if (searchCriteria === "phone") {
          url += `&where[lead.phone][like]=${leadName}`
        } else if (searchCriteria === "dni") {
          url += `&where[lead.dni][like]=${leadName}`
        } else if (searchCriteria === "id") {
          url += `&where[lead][equals]=${leadName}`
        }
      }

      if (leadStatus) {
        url += `&where[lead.status][equals]=${leadStatus}`
      }

      if (selectedSeller) {
        url += `&where[seller][equals]=${selectedSeller}`
      }

      if (andFilters.length > 0) {
        andFilters.forEach((filter, index) => {
          const key = `where[and][${index}][${Object.keys(filter)[0]}][${Object.keys(filter[Object.keys(filter)[0]])[0]}]`;
          const value = Object.values(Object.values(filter)[0])[0];
          url += `&${key}=${value}`;
        });
      }

      const response = await axios.get(url);

      setEvents(response.data.docs);

      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)

    } catch (error) {
      console.log(error);
    } finally {
      setLoadingStatus(false)
    }
  }

  const getSellers = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/trabajadores?depth=0&limit=0&where[activo][equals]=true&where[area][equals]=Comercial`);
      setSellers(response.data.docs);
    } catch (error) {
      console.log(error);
    }
  }

  const getValoresKPIs = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/reglasValoresKPIs?limit=0`)
      setValoresKPIs(response.data.docs)
    } catch (e) {
      toast.error("No se pudieron obtener los valores de los KPIs: " + e)
    }
  }

  const handleResetSearch = () => {
    setLeadName("")
  }

  const handleSearchClients = () => {
    // setPage(1)
    getEvents()
  }

  // const handlePageChange = (event, value) => { // Cambiar la página
  //   setPage(value)
  // }

  useEffect(() => {
    getEvents();
    getSellers();
    getValoresKPIs();
  }, []);

  useEffect(() => {
    getEvents();
  }, [leadStatus, selectedSeller, startDate, endDate, eventType, eventSubType]);

  useEffect(() => {
    if (events.length > 0 && valoresKPIs.length > 0) {
      // Calcular KPIs por trabajador
      const kpisPorTrabajador = events.reduce((acc, event) => {
        const sellerId = event.seller?.id;
        if (!sellerId) return acc;

        // Obtener el valor del KPI para este evento
        const valorKPI = valoresKPIs.find(kpi => kpi.subestado === event.eventSubType)?.valor || 0;

        // Sumar al acumulado del trabajador
        acc[sellerId] = (acc[sellerId] || 0) + valorKPI;

        return acc;
      }, {});

      setWorkerKPIs(kpisPorTrabajador);
    }
  }, [events, valoresKPIs]);

  useEffect(() => {
    if (leadName === "") {
      getEvents(); 
      // setPage(1);
    }
  }, [leadName]);

  const ColorMap = {
    "Lead": "text-yellow-400",
    "Prospecto": "text-blue-500",
    "Cliente": "text-green-500",
  }
  
  return (
    <div className="flex flex-col h-screen w-full">

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          
          <div className="flex items-center gap-4 py-4">
            <FaChartBar className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Trazabilidad de leads individual</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">

            {/* <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Límite:</span>
              <select
                value={limit}
                onChange={(e) => setLimit(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div> */}

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span className="truncate">Buscar por:</span>
              <select
                value={searchCriteria}
                onChange={(e) => setSearchCriteria(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="leadName">Nombre de lead</option>
                <option value="phone">Número de teléfono</option>
                <option value="dni">DNI</option>
                <option value="id">ID</option>
              </select>
            </div>

            <div className="relative w-full">
              <input
                type="text"
                placeholder={`Buscar lead`}
                className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={leadName}
                onChange={(e) => setLeadName(e.target.value)}
              />
              {leadName && (
                <FaTimes
                  onClick={() => handleResetSearch()}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
                />
              )}
            </div>

            <div>
              <Button
                variant="contained"
                endIcon={<SearchIcon />}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => handleSearchClients()}
              >
                Buscar
              </Button>
            </div>

          </div>

        </div>
      </div>

      {/* Resumen de KPIs por trabajador */}
      <div className="flex bg-gray-100 mt-0.5 w-full gap-10 px-8 py-1">
        <div className="flex flex-row justify-between w-full items-center gap-4">
          <div className="flex flex-row items-center gap-4">
            {sellers.map(seller => (
              <span key={seller.id} className="flex items-center gap-2">
                <span className="text-xs text-gray-700">{seller.name}:</span>
                <span className={`text-xs font-bold ${GetDynamicColor(workerKPIs[seller.id] || 0, ColorMapKPIs)}`}>
                  {(workerKPIs[seller.id] || 0).toFixed(1)}
                </span>
              </span>
            ))}
          </div>
          <div className="flex flex-row items-center gap-4">
            <span className="text-xs font-bold text-gray-700">
              Puntaje global: <span className="text-gray-700">{Object.values(workerKPIs).reduce((acc, curr) => acc + curr, 0).toFixed(1)} pts</span>
            </span>
          </div>
        </div>
      </div>

      {/* Agregar una sección para mostrar los valores globales */}
      <div className="flex bg-gray-100 mt-0.5 w-full gap-10 px-8 py-1">
        <div className="flex flex-row items-center justify-between w-full gap-4">
          <span className="text-xs text-gray-700">
            Llamadas totales: <span className="text-gray-700 font-bold"> {eventosLlamadas.length} / {((eventosLlamadas.length / events.length) * 100).toFixed(1)}% </span> 
          </span>
          <span className="text-xs text-gray-700">
            Meets totales: <span className="text-gray-700 font-bold"> {eventosMeets.length} / {((eventosMeets.length / events.length) * 100).toFixed(1)}% </span>
          </span>
          <span className="text-xs text-gray-700">
            Total de entradas al sistema: <span className="text-gray-700 font-bold">{eventosEntradas.length} / {((eventosEntradas.length / events.length) * 100).toFixed(1)}% </span>
          </span>
          <span className="text-xs text-gray-700">
            Cotizaciones totales: <span className="text-gray-700 font-bold"> {eventosCotizaciones.length} / {((eventosCotizaciones.length / events.length) * 100).toFixed(1)}% </span>
          </span>
        </div>
      </div>

      {/* Barra de filtros */}
      <div className="flex bg-gray-100 mt-0.5 mb-0.5 justify-between w-full gap-10">
        <div className="flex flex-row w-full justify-between overflow-x-auto gap-4 px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row items-center justify-between gap-4 px-4">

            {/* Vendedoras */}
            {isAdmin && (
              <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
                <span>Vendedores:</span>
                <select
                  value={selectedSeller}
                  onChange={(e) => setSelectedSeller(e.target.value)}
                  className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                >
                  <option value="">Todos</option>
                  {sellers.map((s) => (
                    <option key={s.id} value={s.id}>{s.name}</option>
                  ))}
                </select>
              </div>
            )}

            {/* Filtro lead status */}
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Estado lead:</span>
              <select
                value={leadStatus}
                onChange={(e) => setLeadStatus(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="">Todos</option>
                <option value="Lead">Lead</option>
                <option value="Prospecto">Prospecto</option>
                <option value="Cliente">Cliente</option>
              </select>
            </div>

            {/* Fechas */}
            <div className="flex flex-row gap-4 items-center justify-start w-full px-4">

              <div className="flex flec-row items-center justify-center gap-2">
                <label className="block text-xs font-medium text-gray-900">
                  Fecha inicio
                </label>

                <div className="flex flex-row items-center justify-center gap-4">
                  <input 
                    type="date" 
                    className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                    value={new Date(startDate).toISOString().split('T')[0]}
                    onChange={(e) => setStartDate(new Date(e.target.value).toISOString())}
                  />
                </div> 
              </div>

              <div className="flex flec-row items-center justify-center gap-2">
                <label className="block text-xs font-medium text-gray-900">
                  Fecha fin
                </label>

                <div className="flex flex-row items-center justify-center gap-4">
                  <input 
                    type="date" 
                    className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                    value={new Date(endDate).toISOString().split('T')[0]}
                    onChange={(e) => setEndDate(new Date(e.target.value).toISOString())}
                  />
                </div> 
              </div>

            </div>  

            
            {/* Tipo evento */}
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span className="text-xs truncate font-semibold">Tipo evento:</span>
              <select
                value={eventType}
                onChange={(e) => setEventType(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
              >
                <option value="">Todos</option>
                <option value="Entrada al sistema">Entrada al sistema</option>
                <option value="Llamada">Llamada</option>
                <option value="Google Meet">Google Meet</option>
                <option value="Cambio estado cotización">Cambio estado cotización</option>
              </select>
            </div>

            {/* Subtipo evento */}
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span className="text-xs truncate font-semibold">Subtipo evento:</span>
              <select
                value={eventSubType}
                onChange={(e) => setEventSubType(e.target.value)}
                className="text-gray-700 min-w-[200px] hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
              >
                <option value="">Todos</option>
                {eventType === "Entrada al sistema" && (
                  <option value="Entrada al sistema">Entrada al sistema</option>
                )}
                {eventType === "Llamada" && (
                  <>
                    <option value="Llamada perdida">Llamada perdida</option>
                    <option value="Llamada corta">Llamada corta</option>
                    <option value="Llamada fria">Llamada fria</option>
                    <option value="Llamada atendida">Llamada atendida</option>
                  </>
                )}
                {eventType === "Google Meet" && (
                  <>
                    <option value="Meet cancelado">Meet cancelado</option>
                    <option value="Meet reagendado">Meet reagendado</option>
                    <option value="Meet agendado">Meet agendado</option>
                    <option value="Meet atendido">Meet atendido</option>
                  </>
                )}
                {eventType === "Cambio estado cotización" && (
                  <>
                    <option value="Exito">Exito</option>
                    <option value="Evaluando opciones">Evaluando opciones</option>
                    <option value="Para el futuro">Para el futuro</option>
                    <option value="Frio">Frio</option>
                    <option value="Por confirmar depósito">Por confirmar depósito</option>
                    <option value="Curioso">Curioso</option>
                    <option value="No responde">No responde</option>
                    <option value="El servicio le parece caro">El servicio le parece caro</option>
                    <option value="Decidió trabajar con otra agencia">Decidió trabajar con otra agencia</option>
                    <option value="Decidió trabajar con un freelancer">Decidió trabajar con un freelancer</option>
                    <option value="No esta en mi ciudad">No esta en mi ciudad</option>
                    <option value="Competencia o sospechoso">Competencia o sospechoso</option>
                    <option value="Lead con poco presupuesto">Lead con poco presupuesto</option>
                  </>
                )}
              </select>
            </div>

          </div>
        </div>
      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loadingStatus ? (
            <LoadingScreen />
          ) : (
            events.length === 0 ? (
              <NoDataScreen />
            ) : (
              <div className="w-full">
                <table className="w-full text-xs">
                  <thead className="text-xs sticky top-0 z-50 text-gray-900 bg-gray-200 ">
                    <tr className="text-gray-700 text-center text-[10px] font-bold">
                      <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Detalles
                      </td>
                      <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Usuario
                      </td>
                      <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Teléfono
                      </td>
                      <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Tipo de usuario
                      </td>
                      <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Vendedor
                      </td>
                      <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Fecha creación
                      </td>
                      <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Hora creación
                      </td>
                      <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red whitespace-pre-line">
                        Fecha evento{"\n"}(Google Meet)
                      </td>
                      <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Tipo evento
                      </td>
                      <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Duración llamada
                      </td>
                      <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Subtipo evento
                      </td>
                      <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Puntaje evento
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {events.map((event) => (
                      <tr 
                        key={event.id}
                        className="text-xs py-2 w-full hover:bg-gray-100 transition-all duration-100"
                      >
                        <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                          <a 
                            href={`/home/trackeoLeads/${event.lead.id}`} 
                            className="hover:underline transition-all duration-100"
                            target="_blank"
                          >
                            <DetailsButton content="Ver detalles" />
                          </a>                       
                        </td>
                        <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                          {event.lead.leadName}
                        </td>
                        <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                          {event.lead.phone}
                        </td>
                        <td className={`px-6 py-2 max-w-xs truncate border border-gray-300 text-center ${GetStatusColor(event.lead.status, ColorMap)}`}>
                          {event.lead.status}
                        </td>
                        <td className={`${event?.seller?.name ? "" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
                          {event?.seller?.name ? event.seller.name : "No asignado"}
                        </td>
                        <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                          {new Date(event.createdAt).getDate()}-
                          {new Date(event.createdAt).toLocaleDateString('es-ES', {
                            month: 'long'
                          })}-
                          {new Date(event.createdAt).getFullYear()}
                        </td>
                        <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                          {new Date(event.createdAt).toLocaleTimeString('es-ES', {
                            hour: '2-digit',
                            minute: '2-digit',
                          })}
                        </td>
                        <td className={`px-6 py-2 max-w-xs truncate border border-gray-300 text-center ${event.scheduledDate ? "" : "text-gray-200"}`}>
                          {event.scheduledDate ? new Date(event.scheduledDate).toLocaleString('es-ES', {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                          }) : "No aplica"}
                        </td>
                        <td className={`${event.eventType ? "" : "text-gray-200"} px-4 py-2 max-w-xs truncate border border-gray-300 text-center`}>
                          {event.eventType ? event.eventType + (event.eventType === "Entrada al sistema" ? ` \n (${event.lead.entryOrigin})` : "") : "No definido"}
                        </td>
                        <td className={`${event.callDuration ? "" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
                          {event.callDuration ? `${event.callDuration} segundos` : "No definido"}
                        </td>
                        <td className={`${event.eventSubType ? "" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
                          {event.eventSubType ? event.eventSubType : "No definido"}
                        </td>
                        <td className={`${valoresKPIs.find(kpi => kpi.subestado === event.eventSubType)?.valor ? "" : "text-gray-200"} font-bold px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
                          {valoresKPIs.find(kpi => kpi.subestado === event.eventSubType)?.valor || 0}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )
          )
        }
      </div>
      
    </div>
  )
}

export default DashboardActividadesComercial

